import PropTypes from 'prop-types';
import React from 'react';
import { getIsLeadGen, getMinPrice } from '../../helpers/deals';
import KlarnaPlacement from './KlarnaPlacement';

const KlarnaMessaging = ({
  deal,
  isKlarnaDeal,
  isKlarnaPayInThree,
  isMarketingCreditDeal,
  sideBar,
}) => {
  const isLeadGen = getIsLeadGen(deal);
  const isKlarnaEnabled = JSON.parse(
    process.env.NEXT_PUBLIC_KLARNA_ENABLED === 'true',
  );

  if (!isKlarnaEnabled || isLeadGen || !isKlarnaDeal) {
    return null;
  }

  const minPrice = getMinPrice(deal);

  return (
    <>
      <div className="klarna-container" data-testid="klarna-container">
        <KlarnaPlacement
          isKlarnaPayInThree={isKlarnaPayInThree}
          price={isMarketingCreditDeal ? deal.vipPrice : minPrice}
          sidebar={sideBar}
        />
      </div>
      <style jsx>{`
        .klarna-container {
          padding-bottom: 3px;
        }
      `}</style>
    </>
  );
};

KlarnaMessaging.propTypes = {
  deal: PropTypes.object,
  isKlarnaDeal: PropTypes.bool,
  isKlarnaPayInThree: PropTypes.bool,
  isMarketingCreditDeal: PropTypes.bool,
  sideBar: PropTypes.bool,
};

KlarnaMessaging.defaultProps = { deal: {}, sideBar: false };

export default KlarnaMessaging;
